<p-dialog
  [(visible)]="display"
  [style]="{ width: '40vw' }"
  (onHide)="reloadDocumentDetail()"
  [modal]="true"
>
  <div *ngIf="errorMessages.length > 0">
    <p-messages severity="error">
      <ng-template pTemplate>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">Please correct the following errors.</span>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </ng-template>
    </p-messages>
  </div>
  <ng-template pTemplate="header">
    <b>Previous Phase Reason</b>
  </ng-template>
  <p>
    You must enter the reason why the Document Version is sent back to a
    previous phase
  </p>

  <div class="field field-required">
    <bpt-dropdown
      label="Phase*"
      [options]="documentPhasesData"
      [(ngModel)]="previousPhase"
      [editable]="false"
      placeholder="Select Phase"
      id="documentPreviousPhase"
      [showClear]="true"
      [showFilter]="true"
      [valueField]="valueField"
      [labelField]="labelField"
      [ngClass]="{ 'error-highlight': mandatoryFields.previousPhase }"
    >
    </bpt-dropdown>
  </div>

  <div class="field field-required">
    <bpt-text-input
      [ngClass]="{ 'error-highlight': mandatoryFields.reasonForChange }"
      [highlightAllOnFocus]="true"
      placeholder="Enter the Reason"
      [multiLine]="true"
      id="reasonForPhaseChangeDescription"
      label="Reason*"
      [(ngModel)]="reasonForChange"
    ></bpt-text-input>
  </div>

  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="Save"
      type="submit"
      id="saveReasonForChangeButton"
      class="align-right"
      (debounceClick)="saveReasonForChange()"
    >
    </p-button>
  </ng-template>
</p-dialog>
